exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kanban-container {\n    width:-webkit-max-content;\n    width:-moz-max-content;\n    width:max-content;    \n    overflow-x: scroll;\n    overflow-y: hidden;\n    padding-top: 10px;\n    margin-left: 0px !important;        \n}\n\n.card-heading {\n    min-height: 75px;\n}\n\n.card-archived {\n    background: #dadada;\n}\n\n.card-body {\n    padding: 7px;\n    height: 500px;\n    overflow-y: scroll;\n}\n\n.col-md-custom{\n    width: 280px !important;\n    float: left;\n    position: relative;\n    min-height: 1px;\n}\n\n.colums {\n    min-width: 270px !important;\n    max-width: 300px !important;\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n}\n\n\n.item-candidate-not-read {\n    background: rgba(0, 0, 0, 0.14);\n}\n\n.item-candidate-feedback {\n    background: rgba(188, 255, 32, 0.4);\n}\n\n.list-group-item-archived {\n    background: #dadada;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/kanban/kanban.component.css
// module id = ../../../../../src/app/pages/kanban/kanban.component.css
// module chunks = main